import { COUNTRY_CONFIG } from '../constants/countries';
import { Country } from '../gql/generated/graphql';

export const getEstimatedOverageFee = (mileage: number, country: Country): number => {
  const { allowance, rate } = COUNTRY_CONFIG[country].odometer.overage;
  return (mileage - allowance) * rate;
};

export const overMileageWarningApplicable = (mileage: number, country: Country): boolean =>
  getEstimatedOverageFee(mileage, country) >= 150;
